export default Object.freeze({
  BLOG_ACCESS: 'blog-access',
  BLOG_WRITE: 'blog-write',
  MULTI_DOMAIN_PUBLISHING_ACCESS: 'multi-domain-publishing',
  DESIGN_MANAGER_ACCESS: 'design-manager-access',
  LANDINGPAGES_ACCESS: 'landingpages-access',
  LANDINGPAGES_ADVANCED_WRITE: 'landingpages-advanced-write',
  LANDINGPAGES_TRUSTED: 'landingpages-trusted',
  PAGES_WRITE: 'pages-write',
  SITEPAGES_ACCESS: 'sitepages-access',
  THEME_WRITE_ACCESS: 'website-theme-write-access',
  THEME_PRESETS_ACCESS: 'default-theme-presets',
  BRANDED_THEME_PRESETS_ACCESS: 'branded-theme-presets'
});